<mat-card>
  <mat-card-header><h1>Release notes</h1></mat-card-header>
  <mat-card-content>
        <mat-list role="list">
      <div mat-subheader><b>Release 3.4.4</b> - {{ formatDate(releaseDates['3.4.4']) }}</div>
      <mat-list-item role="listitem">Rimosso limite ad 8 files in upload allegati</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.4.3</b> - {{ formatDate(releaseDates['3.4.3']) }}</div>
      <mat-list-item role="listitem">Risolto problema di accesso e logout</mat-list-item>
      <mat-list-item role="listitem">Risolto visualizzazione materiale nei beni</mat-list-item>
      <mat-list-item role="listitem">Ricerca veloce aggiunta per tutti i tipi di schede</mat-list-item>
      <mat-list-item role="listitem">Sincronizzazione modifiche con collection service</mat-list-item>
      <mat-list-item role="listitem">Deseleziona tutto in lista selezione collezioni</mat-list-item>
      <mat-list-item role="listitem">Aggiunto link agli oggetti dalla tabella base</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.4.2</b> - {{ formatDate(releaseDates['3.4.2']) }}</div>
      <mat-list-item role="listitem">Aggiunto dropdown button con link collezioni nella pagina di ogni bene</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.4.1</b> - {{ formatDate(releaseDates['3.4.1']) }}</div>
      <mat-list-item role="listitem">Miglioramento ordinamento collezioni per data di aggiornamento</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.4.0</b> - {{ formatDate(releaseDates['3.4.0']) }}</div>
      <mat-list-item role="listitem">Uniformazione layout tabelle</mat-list-item>
      <mat-list-item role="listitem">Fix recupero immagini da sorgente scheda</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.3.5</b> - {{ formatDate(releaseDates['3.3.5']) }}</div>
      <mat-list-item role="listitem">Fix spaziatura datatable</mat-list-item>
      <mat-list-item role="listitem">Fix CSS datatable OA</mat-list-item>
      <mat-list-item role="listitem">Fix dimensione thumbnail</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.3.4</b> - {{ formatDate(releaseDates['3.3.4']) }}</div>
      <mat-list-item role="listitem">Download immagine principale a dimensione originale</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.3.3</b> - {{ formatDate(releaseDates['3.3.3']) }}</div>
      <mat-list-item role="listitem">Rimosso campo "tipo" da stampa</mat-list-item>
      <mat-list-item role="listitem">Ordinamento stampa e aggiunto riferimento</mat-list-item>
      <mat-list-item role="listitem">Fix errori non visualizzati nei campi modulo</mat-list-item>
      <mat-list-item role="listitem">Fix link modifica base scheda</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.3.2</b> - {{ formatDate(releaseDates['3.3.2']) }}</div>
      <mat-list-item role="listitem">Fix dimensioni nella stampa</mat-list-item>
      <mat-list-item role="listitem">Fix beni misti collezione</mat-list-item>
      <mat-list-item role="listitem">Fix stampa elementi collezione</mat-list-item>
      <mat-list-item role="listitem">Fix elementi per pagina collezione</mat-list-item>
      <mat-list-item role="listitem">Fix stampa D, S, F</mat-list-item>
      <mat-list-item role="listitem">Aggiunti MI, D, F, S in elementi collezione</mat-list-item>
      <mat-list-item role="listitem">Formato data DD/MM/YYYY</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.3.0</b></div>
      <mat-list-item role="listitem">Aggiunto spinner di caricamento per aggiunta collezioni</mat-list-item>
      <mat-list-item role="listitem">Ristrutturato pannello di ricerca con selezione collezioni</mat-list-item>
      <mat-list-item role="listitem">Migliorata gestione aggiunta elementi alle collezioni</mat-list-item>
      <mat-list-item role="listitem">Aggiunti pulsanti radio per tipo di ricerca (testo/token)</mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.2.2</b></div>
      <mat-list-item role="listitem">navigazione rapida: fix load immagini su riapertura</mat-list-item>
      <mat-list-item role="listitem">navigazione rapida: fix posizionamento colonne
      </mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: ricerca solo su nome e numero</mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: rimossa unita di misura</mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: ordinamento in ordine alfabetico discendente
      </mat-list-item>
    </mat-list>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.2.1</b> - {{ formatDate(releaseDates['3.2.1']) }}</div>
      <mat-list-item role="listitem">Aggiunta sezione release notes</mat-list-item>
      <mat-list-item role="listitem">navigazione rapida: modifiche di layout e dimensioni della lista dei risultati
      </mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: inserite thumbnail</mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: virtual scroll dei risultati</mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: visualizzazione di solo nome, materiale e misure
      </mat-list-item>
      <mat-list-item role="listitem">Navigazione rapida: ordinamento raggruppato con scheda madre in testa
      </mat-list-item>
    </mat-list>
    <mat-divider></mat-divider>
    <mat-list role="list">
      <div mat-subheader><b>Release 3.2.0</b> - {{ formatDate(releaseDates['3.2.0']) }}</div>
      <mat-list-item role="listitem">navigazione rapida: sincronizzazione con modifiche fatte agli oggetti
      </mat-list-item>
      <mat-list-item role="listitem">Fix calendario nella compilazione</mat-list-item>
      <mat-list-item role="listitem">Fix autore di default</mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>

